import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UserGridItemObject } from '@it2go/types';
import { CardComponent } from '../../../../../components/kit/card/card.component';
import { TextInputComponent } from '../../../../../components/kit/input/text-input/text-input.component';
import { EmailInputComponent } from '../../../../../components/kit/input/text-input/email-input.component';
import { PhoneInputComponent } from 'packages/client/src/app/components/kit/input/phone-input/phone-input.component';

@Component({
    selector: 'app-user-contact-info-card',
    templateUrl: './user-contact-info-card.component.html',
    imports: [CardComponent, TextInputComponent, EmailInputComponent, PhoneInputComponent],
})
export class UserContactInfoCardComponent {
    @Input() form!: FormGroup;
    @Input() canEdit = false;
    @Input() user: UserGridItemObject | null = null;
}
